export default "__VITE_ASSET__18919ff8__"